/*=============================
=        Filter Reviews       =
=============================*/

var currentPage = 1,
	loadMore = document.querySelector('#load-more-reviews'),
	locationFilter = document.querySelector('#filter-location select'),
	currentFilter = locationFilter.value,
	reviewsTop = document.querySelector('#reviews-top .reviews-container'),
	reviewsOther = document.querySelector('#reviews-others .reviews-container');

locationFilter.addEventListener('change', function() {
	currentPage = 1;
	currentFilter = this.value;

	if(this.value)
		this.classList.remove('inactive');
	else
		this.classList.add('inactive');

	axios.post('/reviews-load', {location: currentFilter})
	.then(function(r) {
		reviewsTop.innerHTML = r.data.reviewsTop;
		loadMore.style.display = r.data.last ? 'none' : 'block';

		if(r.data.reviewsOther)
			reviewsOther.parentNode.parentNode.classList.remove('hidden');
		else
			reviewsOther.parentNode.parentNode.classList.add('hidden');

		reviewsOther.innerHTML = r.data.reviewsOther;
		reviewsOther.style = '';
	})
	.catch(function (e) {
		console.log(e);
	});
});

if(loadMore) {
	loadMore.addEventListener('click', function() {
		loadMore.setAttribute('disabled', true);

		reviewsOther.style.minHeight = reviewsOther.offsetHeight+'px';

		axios.post('/reviews-load', {location: currentFilter, page: ++currentPage})
		.then(function(r) {
			if(r.data.reviewsOther) {
				reviewsOther.innerHTML+= r.data.reviewsOther;
				Velocity(reviewsOther, 'slideDown', {duration: 500});
				loadMore.removeAttribute('disabled');

				if(r.data.last)
					loadMore.style.display = 'none';
			}
		})
		.catch(function (e) {
			console.log(e);
		});
	});
}